import { useContext } from 'react'

import { updateAddressField } from '@/common/helpers/helpers'
import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

const useShippingAddress = () => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)

  const updateAddress = e => {
    const { name, value } = e.target

    setRmaInfo(rmaInfo => {
      const currentAddress = rmaInfo.orderInfo.shipping_address

      return {
        ...rmaInfo,
        orderInfo: {
          ...rmaInfo.orderInfo,
          shipping_address: updateAddressField(currentAddress, name, value),
        },
      }
    })
  }

  return {
    updateAddress,
    shippingAddress: rmaInfo?.orderInfo?.shipping_address,
    regionId:
      rmaInfo?.orderInfo?.shipping_address?.province?.id || rmaInfo?.orderInfo?.shipping_address?.country?.region_id,
  }
}

export default useShippingAddress
